import script from "./TrainingReportList.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainingReportList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__